import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  root: {
    margin: 0,
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
})
